export default "__VITE_ASSET__DqoVZ0U6__"